import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { truncateNumberWithPrecision } from 'src/common/helpers/number-helper';
import { IProductDisplayItem } from 'src/common/interfaces/dtos/IProductDisplayItem';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { UnitOfMeasureTypes, UomText } from '../../../common/enumerations/unit-of-measure-type';

interface IQuantityDisplayProps {
  selectedItem: IProductDisplayItem;
  itemList: IElectronicJournalRecord[];
  itemType: EJRecordTypes;
  uomText: string;
  uomsText: string;
}

export const getQuantityDisplay = (props: IQuantityDisplayProps): string => {
  let quantityDisplay = '';
  let quantity: number = 0;

  props.itemList
    .filter(i => i.Type === props.itemType)
    .forEach(item => {
      if (item.Voided || item.ItemId !== props.selectedItem.Id?.toString() || !item.Quantity) {
        return;
      }

      quantity += item.Quantity;
      quantityDisplay =
        props.selectedItem.UnitOfMeasure !== UnitOfMeasureTypes.Each
          ? `${Number(truncateNumberWithPrecision(quantity)).toFixed(2)} ${
              UomText[props.selectedItem.UnitOfMeasure ?? '']
            }`
          : `${quantity} ${quantity > 1 ? props.uomsText : props.uomText}`;
    });

  return quantityDisplay;
};
